export const SET_SKELETON = "SETTINGS/SET_SKELETON";
